module.exports = __webpack_public_path__ + "media/public/images/social/whatsup-8b40251a8126569e6bb70acf9dfca937.svg";